(function (module) {
  "use strict";
  module.controller("tripsDashBoardController", [
    "$rootScope",
    "$scope",
    "$http",
    "$state",
    "tripsDashBoard",
    "progressBar",
    "ngDialog",
    "toastFactory",
    "currency",
    "$filter",
    "$window",
    "commonDialog",
    "commonDialogMessage",
    "uiGridConstants",
    "$q",
    "clientSelectService",
    "agencySelectService",
    "authService",
    "allowIntegrations",
    "socketLogin",
    "$timeout",
    "smsStatus",
    function (
      $rootScope,
      $scope,
      $http,
      $state,
      tripsDashBoard,
      progressBar,
      ngDialog,
      toastFactory,
      currency,
      $filter,
      $window,
      commonDialog,
      commonDialogMessage,
      uiGridConstants,
      $q,
      clientSelectService,
      agencySelectService,
      authService,
      allowIntegrations,
      socketLogin,
      $timeout,
      smsStatus
    ) {
      let storage = $window.localStorage;
      const progress = progressBar.getProgressBar();
      $scope.dateFrom = new Date();
      $scope.dateTo = moment($scope.dateFrom).add(1, "week").toDate();
      $scope.showDetails = false;
      let tripsList = [];
      $scope.bookingListInDetails = [];
      $scope.userRole = authService.getLoginMember().Role;
      $scope.statusNote = {
        Id: 0,
        NewAgentNote: "",
        BookingType: "",
      };
      $scope.isVisible = false;
      storage.setItem("dateFrom", $scope.dateFrom);
      storage.setItem("dateTo", $scope.dateTo);
      let selectedClientId = clientSelectService.getSelectedClient().id;
      let selectedClientName = clientSelectService.getSelectedClient().name;
      $scope.VirtualPaymentAllowed = false;
      $scope.isSearchComplted = false;
      $scope.selectedClientChatAppName = clientSelectService.getSelectedClient().ChatAppName
      function addMonth(startDate) {
        // Does not handle end-of-month edge case, e.g. Oct 31 + 1 month = Dec 01
        return new Date(new Date(startDate).setMonth(startDate.getMonth() + 1));
      }
      function sortByDateAsc(a, b) {
        const firstStartDate = moment(a.StartDate).format("MM-DD-YYYY");
        const secondStartDate = moment(b.StartDate).format("MM-DD-YYYY");
        if (firstStartDate > secondStartDate) {
          return 1;
        } else if (firstStartDate < secondStartDate) {
          return -1;
        } else if (firstStartDate === secondStartDate) {
          if (a.BookingTypeName === "A" && b.BookingTypeName === "A") {
            const tempStartDate = moment(a.StartDate).format(
              "MM-DD-YYYY HH:mm"
            );
            const tempEndDate = moment(b.StartDate).format("MM-DD-YYYY HH:mm");
            if (tempStartDate > tempEndDate) {
              return 1;
            } else {
              return -1;
            }
          } else if (a.BookingTypeName === "A") {
            return -1;
          } else if (b.BookingTypeName === "A") {
            return 1;
          } else if (a.BookingTypeName === "H" && b.BookingTypeName === "C") {
            return -1;
          } else if (a.BookingTypeName === "C" && b.BookingTypeName === "H") {
            return 1;
          } else {
            return 0;
          }
        }
      }

      $scope.loadTripDashboard = function () {
        tripsList = [];
        $scope.isVisible = false;
        $scope.showDetails = false;
        storage.setItem("dateTo", $scope.dateTo);
        storage.setItem("dateFrom", $scope.dateFrom);
        setGridData();
      };
      $scope.resetFilter = function () {
        $scope.dateFrom = new Date();
        $scope.dateTo = addMonth($scope.dateFrom);
        $scope.statusNote = {};
        $scope.showDetails = false;
        $scope.loadTripDashboard();
      };
      $scope.sendSms = function (
        bookingId,
        devicetoken,
        osplatform,
        bookingType
      ) {
        $scope.bookingId = bookingId;
        $scope.devicetoken = devicetoken;
        $scope.osplatform = osplatform;
        $scope.bookingType = bookingType;

        ngDialog.open({
          template: "templates/partials/agentInitiatedMessage.html",
          className: "ngdialog-theme-plain",
          scope: $scope,
          closeByEscape: false,
          closeByDocument: false,
        });
      };
      $scope.confirmSendSms = function () {
        var loginUser = authService.getLoginMember();
        loginMember['SupportsOrganizations'] = []
        console.log("$scope.smsText ", $scope.smsText);
        console.log("$scope.selectedRow ", $scope.selectedRow);
        $http.post("/agentsms", {
          alerttext: $scope.smsText,
          payload: {
            aps: {
              "content-available": 1,
              bookingId: $scope.bookingId,
              bookingType: $scope.bookingType,
              alertText: $scope.smsText,
            },
          },
          devicetoken: $scope.devicetoken,
          osplatform: $scope.osplatform,
          agentEmail: loginUser.Email,
          agencyId: loginUser.Organization.Id,
          travelerEmail: $scope.TravelerEmail,
          clientId: $scope.TravelerCompanyId,
        });
        const traveler = $scope.selectedRow.Traveler;
        console.log("socketId: ", socketLogin.getSocketId());

        var handleData = {
          fromNumber: traveler.Phone,
          socketId: socketLogin.getSocketId(),
          firstName: loginUser.FirstName,
          lastName: loginUser.LastName,
          email: loginUser.Email,
          organizationId: loginUser.Organization.Id,
          loginMember: loginUser,
          smstext: $scope.smsText,
          travelAgencyId: loginUser.Organization.Id,
          travelAgencyName: loginUser.Organization.Name,
          travelAgentFirstName: loginUser.FirstName,
          travelAgentLastName: loginUser.LastName,
          travelAgentEmail: loginUser.Email,
          travelAgentId: loginUser.Id,
          topic: {
            bookingId: $scope.bookingId,
            bookingType: $scope.bookingType,
            email: $scope.TravelerEmail,
            phoneNumber: traveler.Phone,
          },
          travelerFirstName: traveler.FirstName,
          travelerLastName: traveler.LastName,
          travelerOrganizationName: traveler.Organization.Name,
          organizationId: traveler.Organization.Id,
          travelerId: traveler.Id,
          fromDatabase: false,
          status: smsStatus.Live,
          channel: "sms",
        };
        const data = {
          travelerNumber: traveler.Phone,
          travelerFirstName: traveler.FirstName,
          travelerLastName: traveler.LastName,
          travelerEmail: traveler.Email,
          socketId: socketLogin.getSocketId(),
          travelAgentFirstName: loginUser.FirstName,
          travelAgentLastName: loginUser.LastName,
          travelAgentEmail: loginUser.Email,
          travelAgentId: loginUser.Id,
          travelAgentOrganizationId: loginUser.Organization.Id,
          loginMemberId: loginUser.Id,
          smstext: $scope.smsText,
          topic: {
            bookingId: $scope.bookingId,
            bookingType: $scope.bookingType,
            email: traveler.Email,
            phoneNumber: traveler.Phone,
          },
          travelerId: traveler.Id,
          fromDatabase: false,
          channel: "sms",
        };
        $http
          .post("/agentInitiatedSms", data)
          .then((response) => {
            $rootScope.$broadcast("smsHandle", handleData);

            //console.log('Post to /agentInitiatedSms ', handleData);
            return $http.post("/handleConversation", handleData);
          })
          .then(
            (response) => {
              $state.go("app.sms", {
                fromNumber: traveler.Phone,
                travelerFirstName: traveler.FirstName,
                travelerLastName: traveler.LastName,
                travelerOrganizationName: traveler.Organization.Name,
                organizationId: traveler.Organization.Id,
                travelerId: traveler.Id,
                fromDatabase: false,
                status: smsStatus.Live,
                channel: "sms",
                topic: {
                  bookingId: $scope.bookingId,
                  bookingType: $scope.bookingType,
                  email: $scope.TravelerEmail,
                  phoneNumber: traveler.Phone,
                },
              });
            },
            (error) => {
              console.log(error);
            }
          );
      };

      //Cancel popup changes
      $scope.cancelChanges = function () {
        ngDialog.closeThisDialog(1);
      };
      //validate to Date is not less than from date
      function validateToDate(fromDate, toDate) {
        return fromDate <= toDate;
      }
      // Validate that filtered organization id is defined
      function validateAgencyAndClientSelection() {
        const agency = agencySelectService.getSelectedAgency();
        const client = clientSelectService.getSelectedClient();
        return {
          agencyValid: agency.id != null && Number.isInteger(agency.id),
          clientValid: client.id != null && Number.isInteger(client.id),
        };
      }

      function generateNotesHistory() {
        progress.start();
        let id = storage.getItem("id");
        $scope.statusNote.BookingType = storage.getItem("bookingType");
        if ($scope.statusNote.BookingType === "Flight" && $scope.isVisible) {
          tripsDashBoard
            .getFlightsDashById(id)
            .then(
              function (tripsFlights) {
                let tripsFlightsContext = tripsFlights.data.AgentNotes;
                if (tripsFlights.data.HasAgentNotes) {
                  $scope.notesHistoryList = tripsFlightsContext.map(function (
                    agentNote
                  ) {
                    return {
                      Agent:
                        agentNote.Agent.FirstName +
                        " " +
                        agentNote.Agent.LastName,
                      Note: agentNote.Note,
                      NoteTime:
                        $filter("date")(agentNote.LastUpdated, "MM-dd-yyyy") +
                        "   " +
                        $filter("date")(agentNote.LastUpdated, "shortTime"),
                    };
                  });
                }
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: "templates/partials/viewErrorMsg.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = "Notes Error";
                      },
                    ],
                  });
                }
              }
            )
            .finally(function () {
              progress.complete();
            });
        }
        // generate Car booking details
        else if ($scope.statusNote.BookingType === "Car" && $scope.isVisible) {
          tripsDashBoard
            .getCarsDashById(id)
            .then(
              function (tripsCars) {
                let tripsCarsContext = tripsCars.data.AgentNotes;
                if (tripsCars.data.HasAgentNotes) {
                  $scope.notesHistoryList = tripsCarsContext.map(function (
                    agentNote
                  ) {
                    return {
                      Agent:
                        agentNote.Agent.FirstName +
                        " " +
                        agentNote.Agent.LastName,
                      Note: agentNote.Note,
                      NoteTime:
                        $filter("date")(agentNote.LastUpdated, "MM-dd-yyyy") +
                        "   " +
                        $filter("date")(agentNote.LastUpdated, "shortTime"),
                    };
                  });
                }
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: "templates/partials/viewErrorMsg.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = "Notes Error";
                      },
                    ],
                  });
                }
              }
            )
            .finally(function () {
              progress.complete();
            });
        }
        // generate hotel booking details
        else if (
          $scope.statusNote.BookingType === "Hotel" &&
          $scope.isVisible
        ) {
          tripsDashBoard
            .getHotelsDashById(id)
            .then(
              function (tripsHotels) {
                let tripsHotelsContext = tripsHotels.data.AgentNotes;
                if (tripsHotels.data.HasAgentNotes) {
                  $scope.notesHistoryList = tripsHotelsContext.map(function (
                    agentNote
                  ) {
                    return {
                      Agent:
                        agentNote.Agent.FirstName +
                        " " +
                        agentNote.Agent.LastName,
                      Note: agentNote.Note,
                      NoteTime:
                        $filter("date")(agentNote.LastUpdated, "MM-dd-yyyy") +
                        "   " +
                        $filter("date")(agentNote.LastUpdated, "shortTime"),
                    };
                  });
                }
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: "templates/partials/viewErrorMsg.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = "Notes Error";
                      },
                    ],
                  });
                }
              }
            )
            .finally(function () {
              progress.complete();
            });
        } else if (
          $scope.statusNote.BookingType === "Limo" &&
          $scope.isVisible
        ) {
          tripsDashBoard
            .getLimosDashById(id)
            .then(
              function (tripsLimos) {
                let tripsLimosContext = tripsLimos.data.AgentNotes;
                if (tripsLimos.data.HasAgentNotes) {
                  $scope.notesHistoryList = tripsLimosContext.map(function (
                    agentNote
                  ) {
                    return {
                      Agent:
                        agentNote.Agent.FirstName +
                        " " +
                        agentNote.Agent.LastName,
                      Note: agentNote.Note,
                      NoteTime:
                        $filter("date")(agentNote.LastUpdated, "MM-dd-yyyy") +
                        "   " +
                        $filter("date")(agentNote.LastUpdated, "shortTime"),
                    };
                  });
                }
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: "templates/partials/viewErrorMsg.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = "Notes Error";
                      },
                    ],
                  });
                }
              }
            )
            .finally(function () {
              progress.complete();
            });
        }
      }
      $scope.notesHistory = function () {
        $scope.isVisible = $scope.isVisible ? false : true;
        generateNotesHistory();
      };
      $scope.saveBookingStatus = function () {
        progress.start();
        const id = storage.getItem("id");
        $scope.statusNote.BookingType = storage.getItem("bookingType");
        $scope.statusNote.Id = id;
        const toDate = $filter("date")(
          new Date(storage.getItem("dateTo")),
          "yyyy-MM-dd"
        );
        const fromDate = $filter("date")(
          new Date(storage.getItem("dateFrom")),
          "yyyy-MM-dd"
        );
        $scope.dateTo = toDate;
        $scope.dateFrom = fromDate;
        //Update flight booking status
        if ($scope.statusNote.BookingType === "Flight") {
          tripsDashBoard
            .updateFlightStatus(id, $scope.statusNote)
            .then(
              function (flightUpdate) {
                let dialogPost = ngDialog.open({
                  template: "templates/partials/viewSuccessMsg.html",
                  className: "ngdialog-theme-plain",
                  controller: [
                    "$scope",
                    function ($scope) {
                      $scope.successMsg =
                        commonDialogMessage.tripDashStatusUpdatedMessage;
                      $scope.strTitle = "Notes Created Success";
                    },
                  ],
                });
                dialogPost.closePromise.then(function (data) {
                  $scope.statusNote = {};
                  $scope.editStatusForm.$setPristine();
                  if ($scope.isVisible) {
                    generateNotesHistory();
                  }
                });
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: "templates/partials/viewErrorMsg.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = "Notes Error";
                      },
                    ],
                  });
                }
              }
            )
            .finally(function () {
              progress.complete();
            });
        }
        //Update Car booking status
        else if ($scope.statusNote.BookingType === "Car") {
          tripsDashBoard
            .updateCarStatus(id, $scope.statusNote)
            .then(
              function (carUpdate) {
                let dialog = ngDialog.open({
                  template: "templates/partials/viewSuccessMsg.html",
                  className: "ngdialog-theme-plain",
                  controller: [
                    "$scope",
                    function ($scope) {
                      $scope.successMsg =
                        commonDialogMessage.tripDashStatusUpdatedMessage;
                      $scope.strTitle = "Notes Created Success";
                    },
                  ],
                });
                dialog.closePromise.then(function (data) {
                  $scope.statusNote = {};
                  $scope.editStatusForm.$setPristine();
                  if ($scope.isVisible) {
                    generateNotesHistory();
                  }
                });
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: "templates/partials/viewErrorMsg.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = "Notes Error";
                      },
                    ],
                  });
                }
              }
            )
            .finally(function () {
              progress.complete();
            });
        }
        //Update Hotel booking status
        else if ($scope.statusNote.BookingType === "Hotel") {
          tripsDashBoard
            .updateHotelStatus(id, $scope.statusNote)
            .then(
              function (hotelUpdate) {
                let dialogPost = ngDialog.open({
                  template: "templates/partials/viewSuccessMsg.html",
                  className: "ngdialog-theme-plain",
                  controller: [
                    "$scope",
                    function ($scope) {
                      $scope.successMsg =
                        commonDialogMessage.tripDashStatusUpdatedMessage;
                      $scope.strTitle = "Notes Created Success";
                    },
                  ],
                });
                dialogPost.closePromise.then(function (data) {
                  $scope.statusNote = {};
                  $scope.editStatusForm.$setPristine();
                  if ($scope.isVisible) {
                    generateNotesHistory();
                  }
                });
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: "templates/partials/viewErrorMsg.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = "Notes Error";
                      },
                    ],
                  });
                }
              }
            )
            .finally(function () {
              progress.complete();
            });
        }
        //Update Limo booking status
        else if ($scope.statusNote.BookingType === "Limo") {
          tripsDashBoard
            .updateLimoStatus(id, $scope.statusNote)
            .then(
              function (limoUpdate) {
                let dialogPost = ngDialog.open({
                  template: "templates/partials/viewSuccessMsg.html",
                  className: "ngdialog-theme-plain",
                  controller: [
                    "$scope",
                    function ($scope) {
                      $scope.successMsg =
                        commonDialogMessage.tripDashStatusUpdatedMessage;
                      $scope.strTitle = "Notes Created Success";
                    },
                  ],
                });
                dialogPost.closePromise.then(function (data) {
                  $scope.statusNote = {};
                  $scope.editStatusForm.$setPristine();
                  if ($scope.isVisible) {
                    generateNotesHistory();
                  }
                });
              },
              function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: "templates/partials/viewErrorMsg.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = "Notes Error";
                      },
                    ],
                  });
                }
              }
            )
            .finally(function () {
              progress.complete();
            });
        }
      };
      // Begin ui-grid code
      const paginationOptions = {
        pageNumber: 1,
        pageSize: 25,
        sort: null,
      };
      // ui-grid options
      const gridOptions = {
        paginationPageSizes: [5, 10, 25, 50],
        enableFiltering: true,
        enableGridMenu: true,
        paginationPageSize: 25,
        useExternalPagination: false,
        useExternalSorting: false,
        enableRowSelection: true,
        enableSelectAll: false,
        enableRowHeaderSelection: false,
        exporterMenuPdf: false,
        exporterMenuCsv: false,
        multiSelect: false,
        enableColumnResizing: true,
        columnDefs: [
          {
            name: "StartDate",
            visible: true,
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            },
            cellFilter: "date:'MM-dd-yyyy'",
          },
          {
            name: "Seg",
            visible: true,
            displayName: "Seg",
            enableHiding: true,
            enableSorting: false,
            enableFiltering: false,
            enableColumnResizing: true,
            maxWidth: 250,
            cellTemplate:
              '<span><span></span><span ng-if="(row.entity.Seg==0)"><span ng-if="(row.entity.Flight==1)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-plane"></i></span></span>' +
              '<span><span></span><span ng-if="(row.entity.Seg==0)"><span ng-if="(row.entity.Hotel==1)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-bed"></i></span></span>' +
              '<span><span></span><span ng-if="(row.entity.Seg==0)"><span ng-if="(row.entity.Car==1)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-car"></i></span></span>' +
              '<span><span></span><span ng-if="(row.entity.Seg==0)"><span ng-if="(row.entity.Limo==1)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-cab"></i></span></span>' +
              '<span><span></span><span ng-if="(row.entity.Seg==1)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-plane"></i></span>' +
              '<span><span></span><span ng-if="(row.entity.Seg==2)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-car"></i></span>' +
              '<span><span></span><span ng-if="(row.entity.Seg==4)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-cab"></i></span>' +
              '<span><span></span><span ng-if="(row.entity.Seg==3)" style="padding: 0px 2px 2px 2px;"><i class="fa fa-bed"></i></span>',
          },
          {
            name: "TripTitle",
            displayName: "Trip",
            visible: true,
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 300,
          },
          {
            name: "TravelerDisplayName",
            visible: true,
            displayName: "Traveler Name",
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: "Supplier",
            visible: true,
            displayName: "Supplier",
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: "Source",
            visible: true,
            displayName: "Source",
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: "Pnr",
            visible: true,
            displayName: "Pnr",
            enableHiding: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableSorting: true,
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: "StartLocation",
            visible: true,
            displayName: "Start Location",
            enableHiding: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableSorting: true,
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: "EndLocation",
            visible: true,
            displayName: "End Location",
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: "Agent",
            visible: false,
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          },
        ],
        rowTemplate:
          '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
      };
      // End ui-grid option

      $scope.gridDetails = _.cloneDeep(gridOptions);
      $scope.gridDetails.onRegisterApi = function (gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged(
          $scope,
          function (grid, sortColumns) {
            if (!sortColumns.length) {
              paginationOptions.sort = null;
            } else {
              paginationOptions.sort = sortColumns[0].sort.direction;
            }
          }
        );
        // Grid Pagination.
        gridApi.pagination.on.paginationChanged(
          $scope,
          function (newPage, pageSize) {
            updateGridPagination(tripsList);
          }
        );
        // Show trip booking details on grid row selection.
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.bookingListInDetails = [];
          $scope.showDetails = row.isSelected;
          $scope.selectedRow = row.entity;
          $scope.TravelerEmail = row.entity.TravelerEmail;
          $scope.TravelerCompanyId = row.entity.TravelerCompanyId;
          const id = row.entity.Id;
          const bookingType = row.entity.BookingType;
          console.log($scope.selectedRow);
          const errorHandler = (err) => {
            if (err.status != 401) {
              ngDialog.open({
                template: "templates/partials/viewErrorMsg.html",
                className: "ngdialog-theme-plain",
                controller: [
                  "$scope",
                  function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = "Notes Error";
                  },
                ],
              });
            }
          };

          switch (bookingType) {
            case "Trip":
              storage.setItem("tripId", id);
              progress.start();
              tripsDashBoard
                .getTripsDashbyId(id)
                .then((trips) => {
                  const flightList = generateBookingFlight(
                    trips.data.Flights,
                    trips.data.Member
                  );
                  const carList = generateBookingCar(
                    trips.data.Cars,
                    trips.data.Member
                  );
                  const hotelList = generateBookingHotel(
                    trips.data.Hotels,
                    trips.data.Member
                  );
                  const limoList = generateBookingLimo(
                    trips.data.Limos,
                    trips.data.Member
                  );

                  $scope.bookingListInDetails = [].concat(
                    flightList,
                    carList,
                    hotelList,
                    limoList
                  );
                  $scope.bookingListInDetails.sort(sortByDateAsc);
                }, errorHandler)
                .finally(function () {
                  progress.complete();
                });
              break;
            case "Flight":
              storage.setItem("tripId", 0);
              progress.start();
              tripsDashBoard
                .getFlightsDashById(id)
                .then((flights) => {
                  $scope.bookingListInDetails = generateBookingFlight(
                    [flights.data],
                    flights.data.Member
                  );
                }, errorHandler)
                .finally(function () {
                  progress.complete();
                });
              break;
            case "Car":
              storage.setItem("tripId", 0);
              progress.start();
              tripsDashBoard
                .getCarsDashById(id)
                .then((cars) => {
                  $scope.bookingListInDetails = generateBookingCar(
                    [cars.data],
                    cars.data.Member
                  );
                }, errorHandler)
                .finally(function () {
                  progress.complete();
                });
              break;
            case "Hotel":
              storage.setItem("tripId", 0);
              progress.start();
              tripsDashBoard
                .getHotelsDashById(id)
                .then((hotels) => {
                  $scope.bookingListInDetails = generateBookingHotel(
                    [hotels.data],
                    hotels.data.Member
                  );
                }, errorHandler)
                .finally(function () {
                  progress.complete();
                });
              break;
            case "Limo":
              storage.setItem("tripId", 0);
              progress.start();
              tripsDashBoard
                .getLimosDashById(id)
                .then((limos) => {
                  $scope.bookingListInDetails = generateBookingLimo(
                    [limos.data],
                    limos.data.Member
                  );
                }, errorHandler)
                .finally(function () {
                  progress.complete();
                });
              break;
          }
        });
        setGridData();
      };
      //edit status and notes by Id
      generateNotesHistory();
      $scope.editStatus = function (id, bookingType) {
        $scope.statusNote = {};
        $scope.statusNote.BookingType = bookingType;
        storage.setItem("bookingType", bookingType);
        storage.setItem("id", id);
        ngDialog.open({
          template: "templates/partials/editStatusTripDash.html",
          controller: "tripsDashBoardController",
          closeByDocument: false,
        });
      };
      //Show Virtual card on ui
      $scope.showCardDetails = function (bookingData, isConfermaAllowed) {
        $scope.cardImageDataFromParent = {};
        isConfermaAllowed
          ? bookingData.VirtualCardId !== null &&
            bookingData.VirtualCardId !== ""
            ? tripsDashBoard
              .getVirtualCardImage(
                bookingData.VirtualCardId,
                selectedClientId
              )
              .then(
                (response) => {
                  $scope.cardImageDataFromParent = response;
                  ngDialog.open({
                    template: "templates/partials/viewVirtualCard.html",
                    className: "modal-xl ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.flip = function () {
                          angular
                            .element(".virtual-card")
                            .toggleClass("flipped");
                        };
                        $scope.bookingData = bookingData;
                        $scope.cardImageData = response.data;
                      },
                    ],
                    closeByDocument: false,
                  });
                },
                (error) => {
                  showErrorMessage(
                    error.statusText,
                    "Conferma Payment Error"
                  );
                }
              )
            : showErrorMessage(
              "This booking does not have Virtual Card Id, so not showing the conferma.",
              "Details Not Found"
            )
          : showErrorMessage(
            "Conferma virtual payment is not allowed for this organization.",
            "Not Allowed"
          );
      };
      function showErrorMessage(message, title) {
        ngDialog.open({
          template: "templates/partials/viewErrorMsg.html",
          className: "ngdialog-theme-plain sm",
          controller: [
            "$scope",
            function ($scope) {
              $scope.errMsg = `<p>${message}</p>`;
              $scope.errTitle = title;
            },
          ],
        });
      }
      function checkAllowIntegrationForVirtualPayment(id) {
        allowIntegrations
          .getAllowIntegrationsByOrganizationId(id)
          .then(function (response) {
            const integrationData = response.data;
            console.log("integrationData", integrationData);
            if (integrationData) {
              integrationData.forEach(function (integration) {
                console.log(
                  "integration.Name.toLowerCase()",
                  integration.Name.toLowerCase()
                );
                if (
                  integration.Name.toLowerCase() === "conferma" &&
                  integration.Allowed
                ) {
                  $scope.VirtualPaymentAllowed = true;
                }
              });
              console.log(
                "VirtualPaymentAllowed ",
                $scope.VirtualPaymentAllowed
              );
            }
          });
      }
      //Begin function to set ui-grid data
      function setGridData() {
        //$scope.tripsList = [];
        tripsList = [];
        $scope.gridDetails.data = [];
        $scope.gridDetails.totalItems = 0;
        if (authService.getLoginMember().Role === 3) {
          selectedClientId = authService.getLoginMember().OrganizationId;
          selectedClientName = clientSelectService.getSelectedClient().name;
          getTripDashboard(selectedClientId);
          checkAllowIntegrationForVirtualPayment(selectedClientId);
        } else {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            selectedClientId = clientSelectService.getSelectedClient().id;
            selectedClientName = clientSelectService.getSelectedClient().name;
            getTripDashboard(selectedClientId);
            checkAllowIntegrationForVirtualPayment(selectedClientId);
          } else if (valid.agencyValid) {
            //toastFactory.toast_info('Please select a client.');
          } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
          //updateGridPagination($scope.tripsList);
          updateGridPagination(tripsList);
          progress.complete();
        }
      }

      function getTripDashboard(selectedClientId) {
        $scope.isSearchComplted = false;
        progress.start();
        // const organization = clientSelectService.getSelectedClient();
        let dateTo = $filter("date")(
          new Date(storage.getItem("dateTo")),
          "yyyy-MM-dd"
        );
        let dateFrom = $filter("date")(
          new Date(storage.getItem("dateFrom")),
          "yyyy-MM-dd"
        );
        // get trips data
        const promiseTrips = tripsDashBoard.getTripsDash(
          dateFrom,
          dateTo,
          selectedClientId
        );
        const promiseFlights = tripsDashBoard.getFlightsDash(
          dateFrom,
          dateTo,
          selectedClientId
        );
        const promiseCars = tripsDashBoard.getCarsDash(
          dateFrom,
          dateTo,
          selectedClientId
        );
        const promiseHotels = tripsDashBoard.getHotelsDash(
          dateFrom,
          dateTo,
          selectedClientId
        );
        const promiseLimos = tripsDashBoard.getLimosDash(
          dateFrom,
          dateTo,
          selectedClientId
        );

        $q.all([
          promiseTrips,
          promiseFlights,
          promiseCars,
          promiseHotels,
          promiseLimos,
        ])
          .then(
            function (response) {
              progress.complete();
              const tripsContext = response[0].data;
              const flightsContext = response[1].data;
              const carsContext = response[2].data;
              const hotelsContext = response[3].data;
              const limosContext = response[4].data;
              const trips = generateTrips(tripsContext);
              const flightsList = flightsContext.filter(function (flight) {
                return !flight.TripId;
              });
              const flightBookingList = generateBookingFlight(flightsList);

              const carsList = carsContext.filter(function (car) {
                return !car.TripId;
              });
              const carBookingList = generateBookingCar(carsList);

              const hotelsList = hotelsContext.filter(function (hotel) {
                return !hotel.TripId;
              });
              const hotelBookingList = generateBookingHotel(hotelsList);

              const limosList = limosContext.filter(function (limo) {
                return !limo.TripId;
              });
              const limoBookingList = generateBookingLimo(limosList);

              tripsList = [].concat(
                flightBookingList,
                carBookingList,
                hotelBookingList,
                limoBookingList,
                trips,
              )
              $scope.isSearchComplted =
                selectedClientName !== null && selectedClientName !== ''
                  ? true
                  : false
              $scope.isExportData = !!tripsList.length ? true : false
            },
            function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: "templates/partials/viewErrorMsg.html",
                  className: "ngdialog-theme-plain",
                  controller: [
                    "$scope",
                    function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = "Trip Dashboard Error";
                    },
                  ],
                });
              }
              $scope.isSearchComplted = true;
            }
          )
          .finally(function () {
            //assign items to ui grid
            progress.complete();
            //updateGridPagination($scope.tripsList);
            updateGridPagination(tripsList);
          });
      }

      $scope.CloseTripDetails = function () {
        $scope.showDetails = false;
      };
      var allTripsDashboardData = [];
      function updateGridPagination(gridData) {
        allTripsDashboardData = gridData;
        $scope.gridDetails.data = gridData;
        $scope.gridDetails.totalItems = gridData.length;
        const valid = validateAgencyAndClientSelection();
      }

      $scope.exportTripsDashboardData = function () {
        $scope.gridDetails.data = allTripsDashboardData;
        $scope.gridDetails.exporterCsvFilename =
          selectedClientName + "_TripsDashboard.csv";
        $timeout(function () {
          $scope.gridApi.exporter.csvExport("all", "all");
          updateGridPagination(allTripsDashboardData);
        }, 100);
      };

      // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
      $scope.$watch(
        function () {
          return clientSelectService.getSelectedClient();
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            $scope.showDetails = false;
            setGridData();
          }
        },
        true
      );
      //Generate trips data
      function generateTrips(tripsContext) {
        return tripsContext.map(function (trip) {
          let travelerName, name;
          let travelersList = [];
          if (
            trip.Flights.length !== 0 &&
            trip.Flights[0].AirReservation &&
            trip.Flights[0].AirReservation.AirTravelers.length !== 0
          ) {
            travelersList = trip.Flights[0].AirReservation.AirTravelers.map(
              function (traveler) {
                return traveler.LastName + ", " + traveler.GivenName;
              }
            );
          }
          if (
            trip.Flights.length !== 0 &&
            trip.Flights[0].AirReservation &&
            trip.Flights[0].AirReservation.AirTravelers.length !== 0 &&
            trip.Flights[0].AirReservation.AirTravelers[0].LastName !== null &&
            trip.Flights[0].AirReservation.AirTravelers[0].GivenName !== null
          ) {
            travelerName =
              trip.Flights[0].AirReservation.AirTravelers[0].LastName +
              ", " +
              trip.Flights[0].AirReservation.AirTravelers[0].GivenName;
          } else if (
            trip.Hotels.length !== 0 &&
            trip.Hotels[0].GuestNames !== null
          ) {
            name = trip.Hotels[0].GuestNames;
            name = name.split(" ");
            travelerName = name[1] + ", " + name[0];
          } else if (
            trip.Cars.length !== 0 &&
            trip.Cars[0].Travelers !== null
          ) {
            name = trip.Cars[0].Travelers;
            name = name.split(" ");
            travelerName = name[1] + ", " + name[0];
          } else {
            travelerName = trip.Member.LastName + ", " + trip.Member.FirstName;
          }

          if (!travelersList.length) {
            travelersList.push(travelerName);
          }

          return {
            Id: trip.Id,
            StartDate: trip.StartDate,
            Company: !!trip.Member.Organization
              ? trip.Member.Organization.Name
              : "",
            Seg: 0,
            TravelerDisplayName: travelerName,
            Travelers: travelersList,
            //TravelerDisplayName: ((!!trip.Member) ? trip.Member.LastName + ', ' + trip.Member.FirstName : ''),
            Supplier: "-",
            Source: "-",
            Pnr: !!trip.Pnr ? trip.Pnr : "",
            StartLocation: "-",
            EndLocation: "-",
            TripTitle: trip.Title,
            Agent: null,
            //Total: generateTripTotal(trip.Flights, trip.Cars, trip.Hotels),
            BookingType: "Trip", // T-Trips, F-Flights,H-Hotels,C-Cars,
            Flight: !!trip.Flights.length ? 1 : 0,
            Hotel: !!trip.Hotels.length ? 1 : 0,
            Car: !!trip.Cars.length ? 1 : 0,
            Limo: !!trip.Limos.length ? 1 : 0,
            FlightNumber: 0,
            Duration: 0,
            Seat: 0,
            EndDate: trip.EndDate,
            Class: 0,
            Status: 0,
            Type: 0,
            NumberOfRooms: 0,
            Address: 0,
            Rate: 0,
            DeviceToken: !!trip.Member.DeviceToken
              ? trip.Member.DeviceToken
              : null,
            OSPlatform: !!trip.Member.OSPlatform
              ? trip.Member.OSPlatform
              : null,
            TravelerEmail: !!trip.Member.Email ? trip.Member.Email : null,
            TravelerCompanyId: !!trip.Member.Organization.Id
              ? trip.Member.Organization.Id
              : null,
            Traveler: trip.Member,
          };
        });
      }
      // get total for trips
      /*function generateTripTotal(flightData, carData, hotelData) {
        let currencyCode = '';
        let total = 0;
        let arrTotal = [];
        total = flightData.reduce(function(total, flight) {
          if (!!flight.AirReservation && arrTotal.indexOf(flight.AirReservationId) === -1) {
            arrTotal.push(flight.AirReservationId);			
            currencyCode = flight.AirReservation.CurrencyCode;
            return total + flight.AirReservation.TotalFare;
          } else {
            return total + 0;
          }
        }, total);
        total = carData.reduce(function(total, car) {			
          return total + car.TotalCharge;;
        }, total);
        total = hotelData.reduce(function(total, hotel) {
          return total + hotel.Total;
        }, total);
        currencyCode = ((!!hotelData.length && !currencyCode) ? ((!!hotelData[0].CurrencyCode) ? hotelData[0].CurrencyCode :
            currencyCode) :
          currencyCode);
        currencyCode = ((!!carData.length && !currencyCode) ? ((!!carData[0].CurrencyCode) ? carData[0].CurrencyCode :
            currencyCode) :
          currencyCode);
        return currency.getCurrencySymbol(currencyCode) + total.toFixed(2);
      };*/

      function generateBookingFlight(flights, member) {
        return flights.map(function (flight) {
          const travelerName = flight.Member
            ? flight.Member.LastName + ", " + flight.Member.FirstName
            : member
              ? member.LastName + ", " + member.FirstName
              : "";
          return {
            Id: flight.Id,
            BookingTypeName: "A",
            StartDate: flight.DepartureDateTime,
            Company: flight.Member
              ? flight.Member.Organization.Name
              : member
                ? member.Organization.Name
                : "",
            Seg: 1,
            TravelerDisplayName: travelerName,
            Travelers: [travelerName],
            Supplier: flight.OperatingAirline,
            Source: !!flight.BookingSource ? flight.BookingSource : "",
            Pnr: !!flight.Pnr ? flight.Pnr : "",
            StartLocation: flight.DepartureName,
            EndLocation: flight.ArrivalName,
            BookingType: "Flight",
            FlightNumber: flight.FlightNumber,
            Duration: flight.Duration,
            Seat: flight.Seats,
            EndDate: flight.ArrivalDateTime,
            Class:
              (!!flight.BookingClass ? flight.BookingClass : "") +
              (!!flight.BookingClassDescription
                ? " - " + flight.BookingClassDescription
                : ""),
            Status: !!flight.ConfirmationNumber
              ? "Confirmed - " + flight.ConfirmationNumber
              : "",
            Type: 0,
            NumberOfRooms: 0,
            Address: 0,
            Trips: "",
            Agent: null,
            Total:
              currency.getCurrencySymbol(flight.AirReservation.CurrencyCode) +
              flight.AirReservation.TotalFare,
            Flight: 0,
            Hotel: 0,
            Car: 0,
            DeviceToken: flight.Member
              ? flight.Member.DeviceToken
              : member
                ? member.DeviceToken
                : null,
            OSPlatform: flight.Member
              ? flight.Member.OSPlatform
              : member
                ? member.OSPlatform
                : null,
          };
        });
      }

      function generateBookingCar(cars, member) {
        return cars.map(function (car) {
          const travelerName = car.Member
            ? car.Member.LastName + "/" + car.Member.FirstName
            : member
              ? member.LastName + ", " + member.FirstName
              : "";
          return {
            Id: car.Id,
            BookingTypeName: "C",
            StartDate: car.PickUpDateTime,
            Company: car.Member
              ? car.Member.Organization.Name
              : member
                ? member.Organization.Name
                : "",
            Seg: 2,
            TravelerDisplayName: travelerName,
            Travelers: [travelerName],
            Traveler: car.Member
              ? car.Member.LastName + "/" + car.Member.FirstName
              : member
                ? member.LastName + "/" + member.FirstName
                : "",
            Supplier: car.RentalCompany,
            Source: !!car.BookingSource ? car.BookingSource : "",
            Pnr: !!car.Pnr ? car.Pnr : "",
            StartLocation: car.PickUpLocation,
            EndLocation: car.DropOffLocation,
            BookingType: "Car",
            FlightNumber: 0,
            Duration: 0,
            Seat: 0,
            EndDate: car.DropOffDateTime,
            Class: 0,
            Status: !!car.Confirmation ? "Confirmed - " + car.Confirmation : "",
            Type: car.CarModel,
            Trips: "",
            Agent: null,
            Total:
              currency.getCurrencySymbol(car.CurrencyCode) + car.TotalCharge,
            NumberOfRooms: 0,
            Address: 0,
            Flight: 0,
            Hotel: 0,
            Car: 0,
            DeviceToken: car.Member
              ? car.Member.DeviceToken
              : member
                ? member.DeviceToken
                : null,
            OSPlatform: car.Member
              ? car.Member.OSPlatform
              : member
                ? member.OSPlatform
                : null,
          };
        });
      }

      function generateBookingHotel(hotels, member) {
        return hotels.map(function (hotel) {
          const travelerName = !!hotel.GuestNames
            ? hotel.GuestNames
            : hotel.Member
              ? hotel.Member.LastName + "/" + hotel.Member.FirstName
              : member
                ? member.LastName + ", " + member.FirstName
                : "";
          return {
            Id: hotel.Id,
            BookingTypeName: "H",
            StartDate: hotel.CheckInDate,
            Company: hotel.Member
              ? hotel.Member.Organization.Name
              : member
                ? member.Organization.Name
                : "",
            Seg: 3,
            TravelerDisplayName: travelerName,
            Travelers: [travelerName],
            Traveler: hotel.Member
              ? hotel.Member.LastName + "/" + hotel.Member.FirstName
              : member
                ? member.LastName + "/" + member.FirstName
                : "",
            Supplier: hotel.HotelName,
            Source: !!hotel.BookingSource ? hotel.BookingSource : "",
            Pnr: !!hotel.Pnr ? hotel.Pnr : "",
            StartLocation: "",
            EndLocation: "",
            BookingType: "Hotel",
            FlightNumber: 0,
            Duration: 0,
            Seat: 0,
            EndDate: hotel.CheckOutDate,
            Class: 0,
            Status: !!hotel.Confirmation
              ? "Confirmed - " + hotel.Confirmation
              : "",
            Type: hotel.RoomType,
            NumberOfRooms: hotel.NumberOfRooms,
            Address: hotel.Address,
            Trips: "",
            Agent: null,
            Flight: 0,
            Hotel: 1,
            Car: 0,
            Total: currency.getCurrencySymbol(hotel.CurrencyCode) + hotel.Total,
            DeviceToken: hotel.Member
              ? hotel.Member.DeviceToken
              : member
                ? member.DeviceToken
                : null,
            OSPlatform: hotel.Member
              ? hotel.Member.OSPlatform
              : member
                ? member.OSPlatform
                : null,
            VirtualCardId: hotel.VirtualCardId,
          };
        });
      }

      function generateBookingLimo(limoContext, member) {
        return limoContext.map(function (limo) {
          const travelerName = limoContext.Member
            ? limoContext.Member.LastName + ", " + limoContext.Member.FirstName
            : member
              ? member.LastName + ", " + member.FirstName
              : "";
          return {
            Id: limo.Id,
            BookingTypeName: "L",
            DepartureDate: limo.DepartureDate,
            LimoServiceName: limo.LimoServiceName,
            LocationName: limo.LocationName,
            Seg: 4,
            TravelerDisplayName: travelerName,
            Travelers: [travelerName],
            BookingType: "Limo",
            Traveler: member,
            BookingSource: limo.BookingSource,
            Cancelled: limo.Cancelled,
            Confirmation: limo.Confirmation,
            DropOff: limo.DropOff,
            IPCC: limo.IPCC,
            ImageLink: limo.ImageLink,
            Instructions: limo.Instructions,
            PickUp: limo.PickUp,
            Pnr: limo.Pnr,
            Time: limo.Time,
            StartDate: limo.DepartureDate,
          };
        });
      }
    },
  ]);
})(angular.module("obex"));



// WEBPACK FOOTER //
// ./client/js/controllers/tripsDashBoardController.js